import { MassEditWorkingHoursFormData, WEEK_DAYS, WeekDayKey } from "./types";

const createEmptyDayData = () => ({
  enabled: false,
  isOpen: false,
  open: "",
  close: "",
});

export const INITIAL_VALUES: MassEditWorkingHoursFormData = {
  days: Object.keys(WEEK_DAYS).reduce((acc, day) => {
    acc[day as WeekDayKey] = createEmptyDayData();
    return acc;
  }, {} as Record<WeekDayKey, MassEditWorkingHoursFormData["days"][WeekDayKey]>),
  holiday: createEmptyDayData(),
};

export const TIME_VALIDATION_RULES = {
  validate: (value: string) => {
    if (!value) return true;
    const [hours, minutes] = value.split(":").map(Number);
    if (Number.isNaN(hours) || Number.isNaN(minutes)) return false;
    return (
      (hours >= 0 && hours <= 23 && minutes >= 0 && minutes <= 59) ||
      "Horário inválido"
    );
  },
};
